import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-left-payment-panel',
  templateUrl: './left-payment-panel.component.html',
  styleUrls: ['./left-payment-panel.component.scss']
})
export class LeftPaymentPanelComponent implements OnInit {

  paymentOptions = ['Credit Card', 'Debit Card', 'UPI', 'Net Banking', 'Wallet'];
  @Output() paymentGatewayRes = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  gatewaySelected(paymentType) {
    console.log(paymentType);
    this.paymentGatewayRes.emit(paymentType);
  }

}
